var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JobListPreview',{attrs:{"HeaderProps":{ title: _vm.$t('servicesystem.common_objects.job.upcoming jobs'), icon: 'mdi-briefcase-upload' },"JobList":_vm.jobList,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }